<template>
	<div class="header-page">
		<div class="header-cont">
			<div class="header-top">
				<van-search v-model="search" clearable @clear="clear" @search="searchlist" placeholder="请输入用户名或手机号码" />
			</div>
		</div>
		<!-- 筛选组件 -->
		<div class="screen">
			<van-tabs v-model="current" @click="currentChange">
				<van-tab :title="item.label" :name="item.value" v-for="(item, index) in statusOptions"
					:key="index"></van-tab>
			</van-tabs>
		</div>

		<!-- 列表数据 -->
		<div class="list-cont" v-if="cardlistts">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onRefresh">
				<div v-for="(item, index) in cardlist" class="list-tmp" :key="index">
					<div class="uni-flex list-me" style="display: flex">
						<div class="list-le">
							<div class="list-pm">
								<span class="list-span">{{ item.applyName }}</span>
								<span class="list-pan">{{ item.applyPhone }}</span>
							</div>
							<div class="list-yin">
								<span v-if="item.lable" class="list-tag"
									:style="{ backgroundColor: item.lableColorCode }">
									{{ item.lable }}
								</span>
								<span class="lisy-lm">{{ item.applyProductName }}</span>
								<span class="lisy-qm">{{ item.label }}</span>
							</div>
						</div>
						<div class="list-r">
							<div class="list-r-schedule" @click="openUrl(item.bankUrl)">
								{{ item.bankUrl ? '申卡进度 >' : '' }}
							</div>

						</div>
					</div>
					<!--  -->
					<div class="list-data">
						<div class="uni-flex" style="display: flex">
							<div>申请时间：</div>
							<div>{{ item.createTime }}</div>
						</div>
						<div class="uni-flex" style="color: #e02020; display: flex"
							v-if="!merchantCardInfo.merchantType">
							<div>最新更新时间：</div>
							<div>{{ item.lastUpdateTime }}</div>
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<div class="pagesli" v-else>
			<img class="pagesli" src="../../assets/activityUrl/nodata.jpg" alt="" />
		</div>
	</div>
</template>
<script>
	import {
		Toast
	} from 'vant';
	import {
		getOrderStatus,
		getLoansOrderList
	} from '@/api/index';
	import {
		mapState
	} from 'vuex';
	export default {
		data() {
			return {
				loading: false,
				finished: true,
				current: '',
				search: '', //搜索内容
				refresherEnabled: true,
				triggered: false,
				total: 0, //总条数
				pageNum: 1,
				pageSize: 10,
				cardlist: [],
				cardlistts: true,
				status: '',
				statclass: '',
				statusOptions: [{
						label: '全部',
						value: '',
					},
					{
						label: '待确认',
						value: 0,
					},
					{
						label: '已完成',
						value: 1,
					}
				],
				currentIndex: 0,
			};
		},
		mounted() {
			this.getdata();
			this.getOrderStatus();
		},
		computed: {
			...mapState(['merchantCardInfo']),
		},
		methods: {
			scroll() {},
			currentChange(item, index) {
				if (this.currentIndex == index) {
					return;
				}
				this.currentIndex = index;
				this.status = item;

				this.getdata();
			},
			// 获取订单状态下拉
			getOrderStatus() {
				// getOrderStatus(this.$store.getters.getToken).then(res => {
				//     this.statusOptions = res.data;
				//     this.statusOptions.unshift({
				//         label: '全部',
				//         value: '',
				//     });
				// });
			},
			// 数据列表
			async getdata() {
				let data = {
					applyLike: this.search,
					status: this.status,
				};

				const res = await getLoansOrderList(
					this.pageNum,
					this.pageSize,
					data,
					this.$store.getters.getToken
				);
				if (res.code == 200) {
					let rows = res.data.rows;
					if (rows.length > 0) {
						this.cardlistts = true;
					} else {
						this.cardlistts = false;
					}
					if (this.pageNum == 1) {
						this.cardlist = rows;
					} else {
						this.cardlist = [...this.cardlist, ...rows];
					}
					this.total = rows.length;
					for (let i = 0; i < this.cardlist.length; i++) {
						console.log(this.cardlist[i].statusStatistics);
						switch (this.cardlist[i].statusStatistics) {
							case 0:
								this.cardlist[i].statuspay = '审核中';
								this.cardlist[i].statclass = 'list-queq';
								break;
							case 1:
								this.cardlist[i].statuspay = '初审通过';
								this.cardlist[i].statclass = 'list-que';
								break;
							case 2:
								this.cardlist[i].statuspay = '终审通过';
								this.cardlist[i].statclass = 'list-quew';
								break;
							case 3:
								this.cardlist[i].statuspay = '已激活';
								this.cardlist[i].statclass = 'list-quee';
								break;
							case 4:
								this.cardlist[i].statuspay = '已首刷';
								this.cardlist[i].statclass = 'list-quee';
								break;
							case 5:
								this.cardlist[i].statuspay = '拒绝';
								this.cardlist[i].statclass = 'list-quer';
								break;
							case 6:
								this.cardlist[i].statuspay = '非首卡';
								this.cardlist[i].statclass = 'list-que';
								break;
							case 7:
								this.cardlist[i].statuspay = '达标超时';
								this.cardlist[i].statclass = 'list-que';
								break;
						}
					}
				} else {
					// uni.hideLoading()
					// uni.showToast({
					//     title: res.msg,
					//     icon: "none",
					// });
				}
			},
			// 搜索
			searchlist() {
				this.pageNum = 1;
				this.getdata();
			},
			// 清空
			clear() {
				this.search = '';
				this.getdata();
			},
			// 下拉刷新
			onRefresh() {
				this.triggered = 'restore';
				this.search = '';
				let len = this.cardlist.length;
				if (len >= this.total) {
					Toast('数据已加载完成');
					return false;
				} else {
					this.pageNum++;
					this.getdata();
				}
			},
			openUrl(url) {
				if (!url) return;
				window.location.href = url;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.header-page {
		display: flex;
		flex-direction: column;
		overflow: auto;
		height: 100vh;

		.header-cont {
			.header-top {
				width: 100%;
				border-bottom: 3px solid #f7f7f7;

				.mech {
					background-color: #ffffff;
					z-index: 99;
				}
			}
		}

		.list-cont {
			flex: 1;
			position: relative;
			background-color: #ffffff;

			.list-tmp {
				width: 95%;
				border-bottom: 2px solid #f6f6f6;
				padding: 10px 0 10px 0;
				margin: auto;

				.list-me {
					justify-content: space-between;
					// align-items: center;

					.list-pm {
						.list-span {
							padding-right: 10px;
							border-right: 2px solid #f6f6f6;
						}

						.list-pan {
							margin-left: 5px;
						}
					}

					.list-r {
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.list-r-schedule {
							color: rgb(1, 96, 255);
						}
					}

					.list-yin {
						line-height: 45px;
						display: flex;
						align-items: center;

						.list-tag {
							color: #fff;
							height: 20px;
							display: flex;
							align-items: center;
							font-size: 12px;
							padding: 0 4px;
							border-radius: 3px;
							margin-right: 2px;
						}

						.lisy-lm {
							font-weight: bold;
							font-size: 16px;
						}

						.lisy-qm {
							margin-left: 10px;
							border: 1.5px solid red;
							padding: 2px;
							color: red;
							height: 16px;
							line-height: 16px;
							font-size: 8px;
						}
					}

					.list-que {
						color: blue;
						font-weight: bold;
					}

					.list-queq {
						color: #fac858;
						font-weight: bold;
					}

					.list-quew {
						color: #09bb07;
						font-weight: bold;
					}

					.list-quee {
						color: orange;
						font-weight: bold;
					}

					.list-quer {
						color: red;
						font-weight: bold;
					}

					.list-quet {
						color: #8a6de9;
						font-weight: bold;
					}
				}

				.list-data {
					justify-content: space-between;
					color: #838383;
					font-size: 14px;
					line-height: 20px;
				}
			}
		}

		.pagesli {
			height: 100%;
			width: 100%;
			text-align: center;
			background: #ffffff;
		}
	}

	.screen {
		.scroll-view_H {
			white-space: nowrap;
			width: 100%;
			margin: auto;
		}

		.scroll-view_content {
			width: 100%;
		}

		width: 100%;
		display: flex;

		.screen_box {
			text-align: center;
			font-size: 14px;
			color: #606266;
			padding: 4px;
		}
		.van-tabs{
			width: 100%;
		}

		// .screen_box:last-child {
		//   padding-right: 30rpx;
		// }

		.screen_box_active {
			text-align: center;
			position: relative;
			font-size: 14px;
			color: #e02020;
			padding: 4px;
		}

		.screen_box_active::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 15%;
			/* 调整横线左侧的位置，这里设置为div宽度的10% */
			width: 70%;
			/* 横线长度为div宽度的80% */
			height: 1px;
			/* 横线高度为1像素 */
			background-color: #e02020;
			/* 横线颜色为黑色，可以根据需要修改 */
			margin: 0 auto;
			/* 横线居中 */
		}
	}

	.describe {
		margin: 0 10px;
		padding-bottom: 10px;
		font-size: 12px;
		color: #e02020;
	}
</style>